const Blog = () => {
  return (
    <section className="blog">
      <h3>Blog</h3>
    </section>
  )
}

export default Blog
